const selection = window.getSelection();
const range = document.createRange();

export class CopyNodeToClipboard {
  constructor(el) {
    this.el = el;
  }

  getStyle() {
    this.style = this.el.style.userSelect;
    this.webkitStyle = this.el.style.webkitUserSelect;
  }

  setStyle() {
    this.el.style.userSelect = "text";
    this.el.style.webkitUserSelect = "text";
  }

  revertStyle() {
    this.el.style.userSelect = this.style;
    this.el.style.webkitUserSelect = this.webkitStyle;
  }

  setNodeRange() {
    range.selectNodeContents(this.el);
    return range;
  }

  selectNode() {
    this.setNodeRange();
    selection.removeAllRanges();
    selection.addRange(range);
  }

  clearSelection() {
    window.getSelection().removeAllRanges();
  }

  async start() {
    try {
      // Try using Clipboard API as document.execCommand('copy') is not supported for some devices (e.g. iOS)
      const clipboardItem = new ClipboardItem({
        'text/plain': new Blob([this.el.innerText], { type: 'text/plain' }),
        'text/html': new Blob([this.el.outerHTML], { type: 'text/html' }),
      });

      // eslint-disable-next-line compat/compat
      await navigator.clipboard.write([clipboardItem]);
    } catch {
      // If device is not compatible with the Clipboard API use document.execCommand('copy')
      this.getStyle();
      this.setStyle();
      this.selectNode();
      document.execCommand('copy');
      this.clearSelection();
      this.revertStyle();
    }

    this.el.dispatchEvent(
      new Event('clipboardCopy-done', { bubbles: true, composed: true }),
    );
  }
}

export default function copyNodeToClipboard(el) {
  return new CopyNodeToClipboard(el).start();
}
